module.exports = __webpack_public_path__ + "img/hero_boy_chaos_sm.a6fc30b3.png";